export const genID = () => `${Math.random().toString(16).slice(2)}`;

export const getMiddleIndex = (arr: any[]) => Math.floor((arr.length - 1) / 2);

export const toFixed = (num: any, precision: any) => {
  return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
    precision
  );
};
